import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, toDisplayString as _toDisplayString, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d922ec1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TargetDataBox" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { class: "TargetData-table" }
const _hoisted_4 = { class: "paginationCont" }
const _hoisted_5 = { style: {"flex":"auto"} }

import {
  ref,
  reactive,
  onMounted,
  onBeforeUnmount,
  getCurrentInstance,
  toRaw,
  nextTick,
  onUnmounted,
  watch,
  onActivated,
  onDeactivated
} from "vue";
import {
  getTargetPage,
  appTargetDetail,
  reCompares,
} from "@/views/VerificationData/api.js";
import { Search, RefreshRight, Right } from "@element-plus/icons-vue";
import { setField } from "@/utiles/utiles";
import { ElMessage, ElMessageBox } from "element-plus";
import { targetAudit, completionAudit, cancelExceptionReport,targetCompleted } from "./api";
import viewDetail from "./viewDetails.vue";
import { useRouter,onBeforeRouteLeave } from "vue-router";
interface targetInfo {
  farmerInfo: {
    farmerName: string;
    idCard: string;
  };
  ossUrl: string;
  cosUrl: string;
  simTarget: any[];
  payTarget: any[];
  targetInfo: {
    picInfoVoList: any;
    targetName: string;
    targetType: string;
    subjectBatchName: string;
    videoId: string;
    cloudServiceType: string;
  };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TargetData',
  setup(__props) {

const { proxy }: any = getCurrentInstance();
const targetInfo = reactive<targetInfo>({
  farmerInfo: {
    farmerName: "",
    idCard: "",
  },
  ossUrl: "",
  simTarget: [],
  payTarget: [],
  targetInfo: {
    picInfoVoList: [],
    targetName: "",
    subjectBatchName: "",
    targetType: "",
    videoId: "",
  },
});
let insureDetailId = ref("");
const targetBatchs = ref<any>([]);
const farmerId = ref<any>("");
const tableData = ref<any>([]);
const Router = useRouter();
const ruleFormRef = ref();
let insureDawer = ref(false);
const reCompareLoading = ref(false);
const timer = ref(null); // 定时器引用
const direction = ref("rtl");
const submitBtn = ref(true);

const columns = reactive({
  COLLECTING: [
    { label: "理赔编号", prop: "targetNo", width: "auto" },
    { label: "登记号", prop: "earOrCollar", width: "auto" },
    // { label: "畜龄（月）", prop: "livestockAge", width: "auto" },
    { label: "采集时间", prop: "created", width: "auto" },
    {
      label: "异常上报",
      prop: "exceptionReportStatus",
      width: "auto",
      dic: {
        "1": "处理中",
        "2": "已处理"
      }
    }
  ],
  AuditPage: [
    { label: "理赔编号", prop: "targetNo", width: "auto" },
    { label: "登记号", prop: "earOrCollar", width: "auto" },
    
    // { label: "畜龄（月）", prop: "livestockAge", width: "auto" },
    { label: "采集人", prop: "userName", width: "auto" },
    {
      label: "风筛结果",
      prop: "targetStatus",
      width: "auto",
      dic: {
        NORMAL: "唯一理赔标的",
        REPEAT: "疑似重复",
        RELATED: "有关联标的",
      },
    },
    { label: "采集时间", prop: "created", width: "auto" },
    {
      label: "审核确认",
      prop: "paymentResult",
      width: "auto",
      dic: {
        NORMAL: "唯一理赔标的",
        REPEAT: "重复理赔标的",
      },
    },
    { label: "审核人", prop: "auditorName", width: "auto" },
    { label: "审核时间", prop: "auditTime", width: "auto" },
    {
      label: "异常上报",
      prop: "exceptionReportStatus",
      width: "auto",
      dic: {
        "1": "处理中",
        "2": "已处理"
      }
    }
  ],
  audited: [
    { label: "理赔编号", prop: "targetNo", width: "auto" },
    { label: "登记号", prop: "earOrCollar", width: "auto" },
    
    // { label: "畜龄（月）", prop: "livestockAge", width: "auto" },
    { label: "采集人", prop: "userName", width: "auto" },
    { label: "采集时间", prop: "created", width: "auto" },
    {
      label: "风筛结果",
      prop: "targetStatus",
      width: "auto",
      dic: {
        NORMAL: "唯一标的",
        REPEAT: "疑似重复",
        RELATED: "有关联标的",
      },
    },
    {
      label: "审核结果",
      prop: "paymentResult",
      width: "auto",
      dic: {
        NORMAL: "唯一理赔标的",
        REPEAT: "重复理赔标的",
      },
    },
    {
      label: "审核岗",
      prop: "auditorName",
      width: "auto",
    },
    { label: "审核时间", prop: "auditTime", width: "auto" },
  ],
});
const targetType = ref<string>("");
const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);

const userManuallySetPageSize = ref(false);
const calculateTableRows = () => {
  // 如果用户手动设置了页面大小，则不进行自动计算
  if (userManuallySetPageSize.value) {
    return;
  }
  const tableContainer = document.querySelector('.TargetData-table');
  if (!tableContainer) {
    console.log('未找到表格容器');
    return;
  }

  const allRows = document.querySelectorAll('.el-table__row');
  if (!allRows.length) {
    if (!hasInitialSearch.value) {
      hasInitialSearch.value = true;
      onSearch(false);
    }
    return;
  }

  // 计算新的 pageSize
  const totalHeight = Array.from(allRows).reduce((sum, row) => {
    return sum + row.getBoundingClientRect().height;
  }, 0);
  const rowHeight = totalHeight / allRows.length;
  const containerHeight = tableContainer.clientHeight;
  const tableHeader = document.querySelector('.el-table__header');
  const headerHeight = tableHeader ? tableHeader.getBoundingClientRect().height : 0;
  const availableHeight = containerHeight - headerHeight;
  const maxRows = Math.floor(availableHeight / rowHeight);
  const calculatedSize = Math.ceil(maxRows / 5) * 5;

  if (queryForm.pageSize === calculatedSize) {
    return;  // 如果分页大小没变，直接返回
  }

  // 更新分页相关配置
  pageSizes.value = [calculatedSize, calculatedSize * 2, calculatedSize * 3];
  defaultPageSize.value = calculatedSize;
  queryForm.pageSize = calculatedSize;
  onSearch(true);
};
const defaultPageSize = ref(10);
const queryForm = reactive({
  condition: {
    orderId: "",
    caseId: "",
    targetNo: "",
    targetStatus: null,
    insureResult: null,
    paymentResult: null,
    type: "VALIDATE",
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value,
});
let auditForm = reactive({
  targetId: "",
  auditStatus: "",
  auditTargetId: "",
  payStatus: "",
  payTargetId: "",
  type: "VALIDATE",
});
const total = ref(0);
// 生成存储键
const getStorageKey = () => {
  return `targetData_${targetType.value}_params`;
};

// 保存查询参数到 sessionStorage
const saveQueryParams = () => {
  const paramsToSave = {
    pageIndex: queryForm.pageIndex,
    pageSize: queryForm.pageSize,
    targetNo: queryForm.condition.targetNo,
    targetStatus: queryForm.condition.targetStatus,
    paymentResult: queryForm.condition.paymentResult
  };
  sessionStorage.setItem(getStorageKey(), JSON.stringify(paramsToSave));
};

// 从 sessionStorage 恢复查询参数
const restoreQueryParams = () => {
  const savedParams = sessionStorage.getItem(getStorageKey());
  if (savedParams) {
    const parsedParams = JSON.parse(savedParams);
    queryForm.pageIndex = parsedParams.pageIndex || 1;
    queryForm.pageSize = parsedParams.pageSize || defaultPageSize.value;
    
    if (parsedParams.targetNo) {
      queryForm.condition.targetNo = parsedParams.targetNo;
    }
    
    if (targetType.value === 'audited' && parsedParams.paymentResult !== undefined) {
      queryForm.condition.paymentResult = parsedParams.paymentResult;
    }
    
    if (targetType.value === 'AuditPage' && parsedParams.targetStatus !== undefined) {
      queryForm.condition.targetStatus = parsedParams.targetStatus;
    }
    
    return true; // 表示恢复了参数
  }
  return false; // 表示没有恢复参数
};
onActivated(() => {
  // 获取当前路由参数
  const jsonStr = sessionStorage.getItem('claimTargetData') || "{}";
  const claimTargetData = JSON.parse(jsonStr);
  console.log('claimTargetData',claimTargetData);
  const newCaseId = toRaw(Router).currentRoute.value.query.id || claimTargetData.id || "";
  const newTargetType = toRaw(Router).currentRoute.value.query.name || claimTargetData.name || "";
  
  // 检查是否切换了案件或页面类型
  const isSameContext = newCaseId === queryForm.condition.caseId && newTargetType === targetType.value;
  
  // 更新当前值
  queryForm.condition.caseId = newCaseId;
  targetType.value = newTargetType;
  const isReComparing =
    localStorage.getItem(`isReComparing:${queryForm.condition.caseId}`) ===
    "true";
  console.log("进入了onActivated",`isReComparing:${queryForm.condition.caseId}`,localStorage.getItem(`isReComparing:${queryForm.condition.caseId}`));

  if (isReComparing) {
    fetchData(queryForm.condition.caseId);
    startPolling(queryForm.condition.caseId);
  } else {
    setLoadingState(queryForm.condition.caseId, false);
    localStorage.removeItem(`isReComparing:${queryForm.condition.caseId}`);
  }
  if (isSameContext) {
    // 如果是相同上下文，尝试恢复参数
    const restored = restoreQueryParams();
    if (restored) {
      onSearch(false); // 使用恢复的参数查询
      return;
    }
  }
  
  // 如果是新上下文或没有恢复参数，执行初始查询
  onSearch(true);
});
// 存储所有案件的 loading 状态
const caseLoadingStates = ref({});

// 获取或初始化当前案件的 loading 状态
const getLoadingState = (caseId) => {
  if (!caseLoadingStates.value[caseId]) {
    caseLoadingStates.value[caseId] = false; // 默认未加载
  }
  return caseLoadingStates.value[caseId];
};

// 更新指定案件的 loading 状态
const setLoadingState = (caseId, isLoading) => {
  caseLoadingStates.value[caseId] = isLoading;
};
// 存储所有案件的定时器
const timers = {};

// 清理定时器
const cleanupTimer = (caseId) => {
  if (timers[caseId]) {
    clearInterval(timers[caseId]);
    delete timers[caseId];
    console.log(`案件 ${caseId} 的定时器已清除`);
  }
};

// 轮询逻辑
const fetchData = async (caseId) => {
  try {
    const res = await targetCompleted({
      orderOrCaseId: caseId,
      type: "VALIDATE",
    });
    if (res === true) {
      setLoadingState(caseId, false);
      cleanupTimer(caseId);
      localStorage.removeItem(`isReComparing:${caseId}`);
      onSearch(true);
    } else {
      setLoadingState(caseId,true);
    }
  } catch (error) {
    console.error(`案件 ${caseId} 轮询失败:`, error);
  }
};

// 启动轮询
const startPolling = (caseId) => {
  if (!caseId || timers[caseId]) return;
  timers[caseId] = setInterval(() => fetchData(caseId), 3000);
  console.log(`案件 ${caseId} 的定时器已启动`);
};

onDeactivated(() => {
  console.log("进入了onDeactivated");
  cleanupTimer(queryForm.condition.caseId);
});
onMounted(() => {
  nextTick(() => {
    calculateTableRows();
  });
  const jsonStr = sessionStorage.getItem('claimTargetData') || "{}";
  const claimTargetData = JSON.parse(jsonStr);
  console.log('claimTargetData',claimTargetData);
  queryForm.condition.caseId = toRaw(Router).currentRoute.value.query.id || claimTargetData.id || "";
  if (queryForm.condition.caseId) {
    const isReComparing =
      localStorage.getItem(`isReComparing:${queryForm.condition.caseId}`) ===
      "true";
    if (isReComparing) {
      fetchData(queryForm.condition.caseId);
      startPolling(queryForm.condition.caseId);
    } else {
      setLoadingState(queryForm.condition.caseId, false);
      localStorage.removeItem(`isReComparing:${queryForm.condition.caseId}`);
    }
  }
  targetType.value = toRaw(Router).currentRoute.value.query.name || claimTargetData.name || "";
  let name = toRaw(Router).currentRoute.value.name;
  proxy.$doResize(name);
  console.log('首次进入');
  const debouncedCalculate = debounce(calculateTableRows, 200);
  window.addEventListener('resize', debouncedCalculate);
});
watch(tableData, () => {
    if (tableData.value.length > 0) {  // 只在有数据时才重新计算
        nextTick(() => {
            calculateTableRows();
        });
    }
}, { immediate: false });
onUnmounted(() => {
    window.removeEventListener('resize', calculateTableRows);
    userManuallySetPageSize.value = false;
});
const debounce = (fn: Function, delay: number) => {
    let timer: any = null;
    return function (this: any, ...args: any[]) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            userManuallySetPageSize.value = false;
            fn.apply(this, args);
        }, delay);
    };
};

const appTargetDetailFn = (id: any) => {
  appTargetDetail(id).then((res: any) => {
    for (let key in res) {
      const k = key as keyof targetInfo;
      if (res[k]) setField(targetInfo, k, res[k]);
    }

    targetInfo.targetInfo.videoId = targetInfo.targetInfo.cloudServiceType === '1' ? targetInfo.ossUrl + targetInfo.targetInfo.videoId : targetInfo.cosUrl + targetInfo.targetInfo.videoId;
    if (
      targetInfo.simTarget &&
      targetInfo.simTarget.length
    ) {
      targetInfo.simTarget.forEach((item) => {
        item.videoId =item.cloudServiceType === '1' ? targetInfo.ossUrl + item.videoId : targetInfo.cosUrl + item.videoId;
      });
      // if(targetType == 'audited'){
      //   targetInfo.simTarget = targetInfo.simTarget.filter(v=>v.id == targetInfo.targetInfo.acceptSimilarId)
      // }
    } else {
      targetInfo.simTarget = [];
    }
    if (
      targetInfo.payTarget &&
      targetInfo.payTarget.length
    ) {
      targetInfo.payTarget.forEach((item) => {
        item.videoId = item.cloudServiceType === '1' ? targetInfo.ossUrl + item.videoId : targetInfo.cosUrl + item.videoId;
      });
      // if(targetType == 'audited'){
      //   targetInfo.payTarget = targetInfo.payTarget.filter(v=>v.id == targetInfo.targetInfo.paymentSimilarId)
      // }
    } else {
      targetInfo.payTarget = [];
    }
    // isShowSure(!!targetInfo.simTarget.length && !!targetInfo.payTarget.length)
    setForm(res.targetInfo);
    sortPicInfoVoList();
    sortedTargetInfoList();
    sortSimilarTarget();
    console.log("targetInfo.targetInfo", targetInfo.targetInfo);

    insureDawer.value = true;
    auditForm.targetId = id;
  });
};
// 定义排序顺序
const sortOrder = {
  FACE: 1,
  NOSE: 2,
  LEFT_FACE: 3, // 如果LEFT_FACE不需要排序，可以移除这一行和相关的逻辑
};
const sortSimilarTarget = () => {
  if (targetInfo.simTarget) {
    targetInfo.simTarget.map((target) => {
      if (target.picInfoVoList && Array.isArray(target.picInfoVoList)) {
        target.picInfoVoList.sort((a, b) => {
          const orderA = sortOrder[a.picType] || Infinity;
          const orderB = sortOrder[b.picType] || Infinity;
          return orderA - orderB;
        });
      }
    });
  }
};
// 使用map和sort方法对数组进行处理
const sortedTargetInfoList = () => {
  if (targetInfo.payTarget) {
    targetInfo.payTarget.map((target) => {
      if (target.picInfoVoList && Array.isArray(target.picInfoVoList)) {
        target.picInfoVoList.sort((a, b) => {
          const orderA = sortOrder[a.picType] || Infinity;
          const orderB = sortOrder[b.picType] || Infinity;
          return orderA - orderB;
        });
      }
    });
  }
};
// 创建一个方法来排序数组
const sortPicInfoVoList = () => {
  if (
    targetInfo.targetInfo &&
    Array.isArray(targetInfo.targetInfo.picInfoVoList)
  ) {
    // 创建一个新数组来触发响应性更新
    targetInfo.targetInfo.picInfoVoList = reactive([
      ...targetInfo.targetInfo.picInfoVoList,
    ]).sort((a, b) => {
      const orderA = sortOrder[a.picType] || Infinity;
      const orderB = sortOrder[b.picType] || Infinity;
      return orderA - orderB;
    });
  }
};
const isShowSure = (val: boolean) => {
  submitBtn.value = val;
};
const setForm = async (targetInfo: any) => {
  await nextTick();
  auditForm = reactive({
    auditStatus: targetInfo.acceptResult,
    auditTargetId: targetInfo.acceptSimilarId,
    payStatus: targetInfo.paymentResult,
    payTargetId: targetInfo.paymentSimilarId,
    targetId: auditForm.targetId,
    type: "VALIDATE",
  });
  console.log("auditForm1", auditForm);
};
const goBack = () => {
  console.log("Router", Router);
  Router.back();
};
const onSearch = (type: boolean) => {
  tableData.value = [];
  if (type) {
    queryForm.pageIndex = 1;
  }
  if (!queryForm.condition.targetStatus) {
    queryForm.condition.targetStatus = null;
  }
  if (!queryForm.condition.paymentResult) {
    queryForm.condition.paymentResult = null;
  }
  if (!queryForm.condition.insureResult) {
    queryForm.condition.insureResult = null;
  }
  
  // 保存查询参数
  saveQueryParams();
  if (targetType.value === 'audited') {
    queryForm.condition.targetStatus = null;
    queryForm.condition.targetNo = "";
    
  } else if (targetType.value === 'AuditPage') {
    queryForm.condition.paymentResult = null;
  }
  getTargetPage(queryForm).then((res: any) => {
    const { items, totalSize } = res;
    total.value = Number(totalSize);
    tableData.value = items;
  });
};
const cancel = () => {
  insureDawer.value = false;
  for (const key in auditForm) {
    auditForm[key] = "";
    auditForm["type"] = "VALIDATE";
  }
};
// 完成审核
const submitAudit = () => {
  console.log("auditForm", auditForm);
  // return
  if (!auditForm.auditStatus) {
    ElMessage({
      message: "请先选择承保审核结果",
      type: "warning",
    });
    return;
  }
  if (auditForm.auditStatus == "REPEAT" && !auditForm.auditTargetId) {
    ElMessage({
      message: "请先选择承保确认标的",
      type: "error",
    });
    return;
  }

  if (!auditForm.payStatus) {
    ElMessage({
      message: "请先选择理赔审核结果",
      type: "warning",
    });
    return;
  }
  if (auditForm.payStatus == "REPEAT" && !auditForm.payTargetId) {
    ElMessage({
      message: "请先选择理赔确认标的",
      type: "error",
    });
    return;
  }
  targetAudit(auditForm).then((res: any) => {
    ElMessage({
      message: "已完成审核",
      type: "success",
    });
    cancel();
    onSearch(true);
  });
};

const resetForm = (formEl: any) => {
  if (!formEl) return;
  console.log(formEl);
  formEl.resetFields();
  sessionStorage.removeItem(getStorageKey());
};
// const viewDetails = (row: any) => {
//   appTargetDetailFn(row.id);
//   // Router.push({ name: "viewDetails", query: { id: row.id } });
// };
const viewDetails = (row: any) => {
  saveQueryParams();
  const routeName = toRaw(Router).currentRoute.value.query.name as string;
  // 检查是否是处理中的异常上报
  if ((routeName === 'AuditPage' || routeName === 'COLLECTING') && row.exceptionReportStatus === '1') {
    ElMessageBox.confirm(
      '当前标的上报异常处理中尚未反馈处理结果，需直接审核可选择取消上报',
      '提示',
      {
        confirmButtonText: '取消上报',
        cancelButtonText: '等待处理结果',
        type: 'warning',
        distinguishCancelAndClose: true,
      }
    )
      .then(() => {
        // 点击"取消上报"的逻辑 - 显示第二层确认框
        ElMessageBox.confirm(
          '是否确定自行审核，取消上报',
          '提示',
          {
            confirmButtonText: '确认取消',
            cancelButtonText: '等待处理结果',
            type: 'warning',
            distinguishCancelAndClose: true,
          }
        )
          .then(() => {
            // API
            cancelExceptionReport(row.exceptionReportId).then(() => {
              ElMessage.success('取消成功');
              // 正常进入详情页面
              Router.push({
                name: "updateClaimDetail",
                query: {
                  id: row.id,
                  name: targetType.value,
                  readonly: ((targetType.value === 'AuditPage' || targetType.value === 'COLLECTING') ? 'false' : 'true'),
                  taskId: row.taskId
                }
              });
            }).catch(error => {
              ElMessage.error('取消上报失败: ' + (error.message || '未知错误'));
            });
          })
          .catch(action => {
            // 点击"等待处理结果"
            if (action === 'cancel') {
              // 进入页面但隐藏完成审核按钮
              Router.push({
                name: "updateClaimDetail",
                query: {
                  id: row.id,
                  name: targetType.value,
                  readonly: ((targetType.value === 'AuditPage' || targetType.value === 'COLLECTING') ? 'false' : 'true'),
                  taskId: row.taskId,
                  hideAuditButton: 'true' // 添加参数标识隐藏按钮
                }
              });
            }
          });
      })
      .catch(action => {
        // 第一层点击"等待处理结果"
        if (action === 'cancel') {
          // 进入页面但隐藏完成审核按钮
          Router.push({
            name: "updateClaimDetail",
            query: {
              id: row.id,
              name: targetType.value,
              readonly: ((targetType.value === 'AuditPage' || targetType.value === 'COLLECTING') ? 'false' : 'true'),
              taskId: row.taskId,
              hideAuditButton: 'true' // 添加参数标识隐藏按钮
            }
          });
        }
      });
  } else {
    // 非处理中状态，直接跳转
    Router.push({
      name: "updateClaimDetail",
      query: {
        id: row.id,
        name: targetType.value,
        readonly: ((targetType.value === 'AuditPage' || targetType.value === 'COLLECTING') ? 'false' : 'true'),
        taskId: row.taskId
      }
    });
  }
};
const handleSizeChange = (val: number) => {
  userManuallySetPageSize.value = true; // 设置标志位表示用户手动修改了页面大小
  queryForm.pageSize = val;
  onSearch(true);
};
const handleCurrentChange = (val: number) => {
  queryForm.pageIndex = val;
  onSearch(false);
};

// 完成审核
const completeAudit = () => {
  completionAudit(queryForm.condition.caseId)
    .then(() => {
      ElMessage({
        message: "已完成审核",
        type: "success",
      });
      cancel();
      onSearch(true);
    })
    .catch(() => {});
};

const reCompare = () => {
  setLoadingState(queryForm.condition.caseId, true);
  localStorage.setItem(`isReComparing:${queryForm.condition.caseId}`, "true"); // 标记为对比中
  let data = {
    id: queryForm.condition.caseId,
    type: "CLAIM",
  };
  reCompares(data).then(() => {
    ElMessage({
      message: "正在比对中，请稍候",
      type: "success",
    });
    onSearch(true);
    startPolling(queryForm.condition.caseId);
  }).catch(() => {
    setLoadingState(queryForm.condition.caseId, false);
    localStorage.removeItem(`isReComparing:${queryForm.condition.caseId}`); // 失败时清除标记
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Back = _resolveComponent("Back")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        model: queryForm,
        class: "demo-form-inline",
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        "label-width": "90px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_link, { onClick: goBack }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Back)
                    ]),
                    _: 1
                  }),
                  _createTextVNode("返回")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (targetType.value == 'audited')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_form_item, {
                  label: "理赔编号",
                  prop: "condition.targetNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryForm.condition.targetNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.condition.targetNo) = $event)),
                      modelModifiers: { trim: true },
                      clearable: "",
                      placeholder: "理赔编号",
                      class: "unifiedInputBoxWidth"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "审核结果",
                  prop: "condition.paymentResult"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryForm.condition.paymentResult,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.condition.paymentResult) = $event)),
                      placeholder: "审核结果",
                      class: "unifiedInputBoxWidth",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "唯一理赔标的",
                          value: "NORMAL"
                        }),
                        _createVNode(_component_el_option, {
                          label: "重复理赔标的",
                          value: "REPEAT"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          (targetType.value == 'AuditPage')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "风筛结果",
                prop: "condition.targetStatus"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: queryForm.condition.targetStatus,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.condition.targetStatus) = $event)),
                    placeholder: "风筛结果",
                    class: "unifiedInputBoxWidth",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "唯一理赔标的",
                        value: "NORMAL"
                      }),
                      _createVNode(_component_el_option, {
                        label: "重复理赔标的",
                        value: "REPEAT"
                      }),
                      _createVNode(_component_el_option, {
                        label: "有关联标的",
                        value: "RELATED"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Search),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onSearch(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查 询")
                ]),
                _: 1
              }, 8, ["icon"]),
              (targetType.value != 'COLLECTING')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_button, {
                      icon: _unref(RefreshRight),
                      plain: "",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (resetForm(ruleFormRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重 置")
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    (targetType.value === 'AuditPage')
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: reCompare,
                          loading: getLoadingState(queryForm.condition.caseId)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重新对比验标")
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        data: tableData.value,
        border: "",
        style: {"width":"100%"},
        height: "100%",
        onRowMounted: calculateTableRows
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "60",
            align: "center"
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns[targetType.value], (item) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: item.prop,
              label: item.label,
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                (item.prop === 'earOrCollar')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(row.collarBarcode || row.earNo), 1)
                    ], 64))
                  : (item.dic)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(item.dic[row[item.prop]]), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(row[item.prop]), 1)
                      ], 64))
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "120",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (viewDetails(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查看详情 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "total, sizes, prev, pager, next",
        "page-sizes": pageSizes.value,
        total: total.value,
        "current-page": queryForm.pageIndex,
        "onUpdate:current-page": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.pageIndex) = $event)),
        "page-size": queryForm.pageSize,
        "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.pageSize) = $event)),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
    ]),
    _createVNode(_component_el_dialog, {
      center: "",
      modelValue: _unref(insureDawer),
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(insureDawer) ? (insureDawer).value = $event : insureDawer = $event)),
      title: "验标详情",
      width: "75%",
      onClose: cancel,
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        (_unref(insureDawer))
          ? (_openBlock(), _createBlock(viewDetail, {
              key: 0,
              onIsShowSure: isShowSure,
              onSetForm: setForm,
              form: _unref(auditForm),
              targetType: targetType.value,
              targetInfo: targetInfo,
              id: _unref(insureDetailId)
            }, null, 8, ["form", "targetType", "targetInfo", "id"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_isRef(insureDawer) //@ts-ignore
 ? insureDawer.value = false : insureDawer = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          }),
          (submitBtn.value && targetType.value == 'AuditPage')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: submitAudit,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("完成审核")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})